export const DEBIT_CARD = 'debit-card';
export const DEBIT_CARD_PIN = 'debit-card-pin';
export const DOCUMENTATION = 'documentation';
export const PRE_DOCUMENTATION = 'pre-documentation';
export const LIMIT_CREDIT = 'limit-credit';
export const EXTERNAL_IBAN = 'external-iban';
export const STAND_BY = 'standby';
export const SUCCESS = 'success';
export const COMPLETED = 'completed';
export const ABORTED = 'aborted';
export const BLOCKED = 'blocked';
export const WAITING = 'waiting';
export const ACTIVATED = 'activated';
export const IDENTIFICATION = 'identification';
export const IDENTIFICATION_ROBO = 'identification-robo';
export const IDENTIFICATION_ABORTED = 'identification-aborted';
export const IDENTIFIED = 'identified';
export const IDENTIFIED_ROBO = 'identified-robo';
export const CONTRACT = 'contract';
export const SIGNED = 'signed';
export const FIOC = 'fioc';
export const LIMIT_CREDIT_INE = 'limit-credit-ine';
export const TRANSFER_OTP = 'transfer-otp';
export const PENDING_OTP = 'pending-otp';
export const SIGNATURE_KEY = 'signature-key';

export const DEPOSIT_CONFIG_STATUS = 'deposit-config';
export const CARD_CONFIG_STATUS = 'card-config';
export const BATCH_STATUS = 'batch';
export const CREATED_STATUS = 'created';
export const REGISTER_STATUS = 'register';
export const JAFFAR_STATUS = 'jaffar';
export const READY_STATUS = 'ready';
export const ADDITIONAL_STATUS = 'additional';
export const OBJECTIVES_SELECTION_STATUS = 'objectives-selection';
export const SUITABILITY_TEST_STATUS = 'suitability-test';
export const PRE_CANCELLED_STATUS = 'pre-cancelled';
export const UPDATING_DOCUMENTATION_STATUS = 'updating-documentation';
export const SIMULATION_STATUS = 'simulation';
export const CANCELLED_STATUS = 'cancelled';

export default {
    DEBIT_CARD,
    DEBIT_CARD_PIN,
    DOCUMENTATION,
    PRE_DOCUMENTATION,
    LIMIT_CREDIT,
    EXTERNAL_IBAN,
    STAND_BY,
    SUCCESS,
    COMPLETED,
    ABORTED,
    BLOCKED,
    WAITING,
    LIMIT_CREDIT_INE,
};
